import { apiClient, apiEndpoint } from './api.services';

const BASE = `${apiEndpoint}/system-canvas`;

export const listControlLibraries = (params?: { search?: string; pageIndex?: number; pageSize?: number }) =>
  apiClient.get(`${BASE}/control-libraries`, { params });

export const listControlLibrariesForProduct = (devOrderId: string) =>
  apiClient.get(`${BASE}/control-libraries/for-product/${devOrderId}`);

export const getControlLibraryById = (id: string) => apiClient.get(`${BASE}/control-libraries/${id}`);

export interface LibraryMappingFields {
  libraryName?: string;
  iconUrl?: string;
  brand?: string[];
  subBrand?: string[];
  productType?: string[];
  category1?: string[];
  category2?: string[];
  isActive?: boolean;
}

export const createControlLibrary = (data: LibraryMappingFields) => apiClient.post(`${BASE}/control-libraries`, data);

export const updateControlLibrary = (id: string, patch: LibraryMappingFields) => apiClient.put(`${BASE}/control-libraries/${id}`, patch);

export const deleteControlLibrary = (id: string) => apiClient.delete(`${BASE}/control-libraries/${id}`);

export const listLibraryCards = (libraryId: string, params?: { search?: string; pageIndex?: number; pageSize?: number }) =>
  apiClient.get(`${BASE}/control-libraries/${libraryId}/cards`, { params });

export const createLibraryCard = (libraryId: string, data: { cardName: string; tableControlIds: string[] }) =>
  apiClient.post(`${BASE}/control-libraries/${libraryId}/cards`, data);

export const updateLibraryCard = (libraryId: string, cardId: string, patch: { cardName?: string; tableControlIds?: string[] }) =>
  apiClient.put(`${BASE}/control-libraries/${libraryId}/cards/${cardId}`, patch);

export const deleteLibraryCard = (libraryId: string, cardId: string) => apiClient.delete(`${BASE}/control-libraries/${libraryId}/cards/${cardId}`);

export interface LibraryCardTableData {
  formValues: Record<string, Record<string, unknown>>;
  tableRowCounts: Record<string, number>;
  rowDocuments: Record<string, { current: Record<string, unknown> | null; history: Record<string, unknown>[] }>;
  rowKeys: Record<string, string>;
}

export const saveLibraryCardTableData = (libraryId: string, cardId: string, data: LibraryCardTableData) =>
  apiClient.put(`${BASE}/control-libraries/${libraryId}/cards/${cardId}/table-data`, data);

export const listProductLibraryCards = (productId: string) => apiClient.get(`${BASE}/dev-orders/${productId}/library-cards`);

export const attachLibraryCardToProduct = (productId: string, data: { libraryCardId: string; displayOrder?: number }) =>
  apiClient.post(`${BASE}/dev-orders/${productId}/library-cards`, data);

export const saveProductLibraryCardTableData = (productId: string, id: string, data: LibraryCardTableData) =>
  apiClient.put(`${BASE}/dev-orders/${productId}/library-cards/${id}/table-data`, data);

export const detachLibraryCardFromProduct = (productId: string, id: string) => apiClient.delete(`${BASE}/dev-orders/${productId}/library-cards/${id}`);

/** Upsert: creates product-level entry on first save, updates on subsequent saves */
export const upsertProductLibraryCard = (productId: string, libraryCardId: string, data: LibraryCardTableData) =>
  apiClient.put(`${BASE}/dev-orders/${productId}/library-cards/save-by-card/${libraryCardId}`, data);

/** Search library-level rows for import into a product table */
export const searchLibraryRows = (
  productId: string,
  libraryCardId: string,
  tableId: string,
  search: string,
) => apiClient.get(`${BASE}/dev-orders/${productId}/library-cards/search-rows/${libraryCardId}/${tableId}`, { params: { search } });

export const listTableControls = (params?: { search?: string; pageIndex?: number; pageSize?: number }) =>
  apiClient.get(`${BASE}/controls`, { params });
